const ES = [
  [/^(.+) needs reassignment$/, "$1 necesita reasignación"],
  [/^New professional application$/, "Nueva postulación de profesional"],
  [/^New maid application$/, "Nueva postulación de limpieza"],
  [/^Payment receipt uploaded for (.+)$/, "Comprobante de pago subido para $1"],
  [/^Payment received for (.+)$/, "Pago recibido para $1"],
  [/^New (\d)-star rating on (.+)$/, "Nueva calificación de $1 estrellas en $2"],
  [/^New URGENT request (.+)$/, "Nueva solicitud URGENTE $1"],
  [/^New request (.+)$/, "Nueva solicitud $1"],
  [/^New lead matching your services \((.+)\)$/, "Nuevo cliente para tus servicios ($1)"],
  [/^You were chosen for (.+)$/, "Te eligieron para $1"],
  [/^Customer selected (.+) for (.+)$/, "El cliente eligió a $1 para $2"],
  [/^New job assigned: (.+)$/, "Nuevo trabajo asignado: $1"],
  [/^A professional was assigned to (.+)$/, "Se asignó un profesional a $1"],
  [/^Updated recommendations for (.+)$/, "Recomendaciones actualizadas para $1"],
  [/^(.+) accepted (.+)$/, "$1 aceptó $2"],
  [/^(.+) declined (.+)$/, "$1 rechazó $2"],
  [/^Estimate to review: (.+)$/, "Presupuesto por revisar: $1"],
  [/^Your estimate is ready \((.+)\)$/, "Tu presupuesto está listo ($1)"],
  [/^Estimate approved: (.+)$/, "Presupuesto aprobado: $1"],
  [/^Estimate declined: (.+)$/, "Presupuesto rechazado: $1"],
  [/^(.+) is now: (.+)$/, "$1 ahora está: $2"],
  [/^Visit times proposed for (.+)$/, "Horarios de visita propuestos para $1"],
  [/^New message on (.+)$/, "Nuevo mensaje en $1"],
  [/^(.+) confirmed & closed$/, "$1 confirmada y cerrada"],
  [/^Customer concern on (.+)$/, "Inquietud del cliente en $1"],
  [/^(.+) canceled by customer$/, "$1 cancelada por el cliente"],
  [/^Contractor was removed$/, "El contratista fue eliminado"],
  [/^Accept or decline the job$/, "Acepta o rechaza el trabajo"],
  [/^Estimate coming next$/, "Pronto llegará el presupuesto"],
  [/^Schedule the visit$/, "Programa la visita"],
  [/^Choose your professional$/, "Elige tu profesional"],
];

export const trNotif = (s, lang, t) => {
  if (!s) return s;
  const svc = s.match(/^([a-z_]+) · (.+)$/);
  if (svc) return `${t(`svc.${svc[1]}`)} · ${svc[2]}`;
  if (lang !== "es") return s;
  const hit = ES.find(([re]) => re.test(s));
  return hit ? s.replace(hit[0], hit[1]) : s;
};
